import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  static log(...arg) {
    if (environment.logger) console.log(...arg);
  }

  static warn(...arg) {
    if (environment.logger) console.warn(...arg);
  }

  static error(...arg) {
    if (environment.logger) console.error(...arg);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/log.service.ts